import { IconButton, styled, Typography } from '@chronosphereio/chrono-ui';
import { Close as CloseIcon } from 'mdi-material-ui';
import { memo } from 'react';
import { PIN_TOOLTIP_HELP_TEXT, UNPIN_TOOLTIP_HELP_TEXT } from './model';

export interface PanelTooltipHeaderProps {
  title?: string;
  isPinned?: boolean;
  enablePinning?: boolean;
  onUnpinClick?: () => void;
}

export const PanelTooltipHeader = memo(function PanelTooltipHeader({
  title,
  isPinned = false,
  enablePinning = true,
  onUnpinClick,
}: PanelTooltipHeaderProps) {
  const showPinningHelp = enablePinning;
  const helpText = isPinned ? UNPIN_TOOLTIP_HELP_TEXT : PIN_TOOLTIP_HELP_TEXT;

  if (!enablePinning && !title) {
    return null;
  }

  return (
    <TooltipHeaderWrapper>
      <TooltipHeaderTitleWrapper>
        {title && <TooltipHeaderTitle variant="body2">{title}</TooltipHeaderTitle>}
      </TooltipHeaderTitleWrapper>
      {showPinningHelp && (
        <TooltipHeaderPinWrapper>
          <Typography variant="caption" color="text.placeholder">
            {helpText}
          </Typography>
          {isPinned && onUnpinClick && (
            <TooltipHeaderPinButton
              size="small"
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                onUnpinClick();
              }}
            >
              <CloseIcon fontSize="small" />
            </TooltipHeaderPinButton>
          )}
        </TooltipHeaderPinWrapper>
      )}
    </TooltipHeaderWrapper>
  );
});

const TooltipHeaderWrapper = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 8,
  minHeight: 24,
});

const TooltipHeaderTitleWrapper = styled('div')({
  flex: 1,
  minWidth: 0,
});

const TooltipHeaderTitle = styled(Typography)(({ theme }) => {
  return {
    fontWeight: theme.typography.fontWeightBold,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  };
});

const TooltipHeaderPinWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
});

const TooltipHeaderPinButton = styled(IconButton)({
  padding: 2,
});
